<!-- List -->
<ng-template [ngIf]="isVisualizacaoModoList">
    <sgt-cliente-analise-mercado-cliente-list
        #clienteList
        visualizacaoStorageKey="clienteAnaliseMercadoClienteListVisualizacaoRAP"
        [filter]="filter">
    </sgt-cliente-analise-mercado-cliente-list>
</ng-template>
